import React from "react";
import { Question as QuestionType } from "../../../../Interface/Index";

interface QuestionProps {
  currentQuestion: QuestionType | undefined;
}

const Question: React.FC<QuestionProps> = ({ currentQuestion }) => {
  return (
    <div
      className="question-text"
      style={
        currentQuestion && currentQuestion.type === "coding"
          ? { textAlign: "center", padding: "0px 20px" }
          : {}
      }
    >
      <p>{currentQuestion?.description}</p>
    </div>
  );
};

export default Question;
